<template>
  <px-custom-dialog
    transition="fadet"
    :width="dialogWidth"
    v-model="dialog"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
        <v-btn
          class="normal-btn-text elevation-0 rounded-tag-small"
          small
          v-on="on"
        >
          Vincular OC
        </v-btn>
      </slot>
    </template>
    <template v-slot:title>
      Vincular OC
    </template>
    <div v-if="notaFiscal.id && dialog" class="text--primary">
      <px-cadastro-nota-fiscal-vinculo-compra
        :nota-fiscal="notaFiscal"
        v-model="selectedCompra"
      />
      <v-row v-if="notaFiscal.fornecedor">
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-tag-small"
            label="Observações internas"
            counter="2000"
            rows="2"
            v-model="observacaoInterna"
          />
        </v-col>
      </v-row>
    </div>
    <template v-slot:actions>
      <v-btn class="rounded-tag-small normal-btn-text elevation-0 rounded-tag-small"
             color="primary"
             :disabled="!selectedCompra"
             :loading="loadingVinculo"
             @click="onClickVincular">
        Vincular OC
      </v-btn>
      <v-btn class="rounded-tag-small normal-btn-text elevation-0 rounded-tag-small"
             @click="onClickClose">
        Fechar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import CadastroNotaFiscalVinculoCompra
  from '@/modules/notas-fiscais/vinculo/CadastroNotaFiscalVinculoCompra.vue';
import NotasFiscaisCompraLinkService
  from '@/modules/notas-fiscais/notas-fiscais-compra-link-service';
import TipoLinkNotaFiscalCompra from '@/enums/tipo-link-nota-fiscal-compra';

export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loadingVinculo: false,
      selectedCompra: null,
      observacaoInterna: null,
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '900px';
    },
  },
  methods: {
    buildPayload() {
      return {
        linkType: TipoLinkNotaFiscalCompra.keys.LINK.key,
        compra: {
          id: this.selectedCompra.id,
        },
        notaFiscal: {
          id: this.notaFiscal.id,
        },
        observacaoInterna: this.observacaoInterna,
      };
    },
    onClickClose() {
      this.dialog = false;
    },
    onClickVincular() {
      this.loadingVinculo = true;
      NotasFiscaisCompraLinkService.createLink(this.selectedCompra.id, this.buildPayload())
        .then(({ data }) => {
          this.$emit('change', data);
          this.dialog = false;
        })
        .finally(() => {
          this.loadingVinculo = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.selectedCompra = null;
        this.observacaoInterna = null;
      }
    },
  },
  components: {
    pxCadastroNotaFiscalVinculoCompra: CadastroNotaFiscalVinculoCompra,
  },
};
</script>
